import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Row,
  form,
  Col,
  Input,
  SelectPicker,
  Icon,
  Button,
  DatePicker,
  ControlLabel,
} from 'rsuite'
import {
  isImageOrPdf,
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function BookProjectBudgetForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  ControlLabel,
  control,
  setValue,
  clearErrors,
  getValues,
  ...props
}) {
  // const [formSchema, setFormSchema] = useState(props.schema)
  const [formSchema, setFormSchema] = useState(_schema)
  // console.log("tets3",_schema)

  const { handleSubmit } = useForm()
  const [isShowConfirm, setIsShowConfirm] = useState(false)

  const onSubmit = (data) => {
    console.log('data', data)
    setIsShowConfirm(true)
  }
  const handleCallService = () => {
    try {
      setIsShowConfirm(false)
    } catch (error) {}
  }

  return (
    <>
      <Panel collapsible defaultExpanded header={'จองงบ'}>
        <Row>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>รหัสโครงการ :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.projectCode.name]} />
            <Input
              name={formSchema.projectCode.name}
              defaultValue={formSchema.projectCode.value}
              inputRef={register(isValidators(formSchema.projectCode.validators))}
              placeholder={'กรุณากรอก' + formSchema.projectCode.label}
              disabled={formSchema.projectCode.disabled}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>Mode :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.modeGrantRe.name]} />
            <Controller
              name={formSchema.modeGrantRe.name}
              control={control}
              defaultValue={formSchema.modeGrantRe.value}
              rules={isValidators(formSchema.modeGrantRe.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.modeGrantRe.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'กรุณาเลือก'}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>
            <CancelButton>{'ยกเลิก'}</CancelButton>
          </Col>
        </Row>
      </Panel>
      <hr />
      <Panel collapsible defaultExpanded header={'จองแยกงวดเงิน'}>
        <Row>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>รหัสโครงการ :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.projectCode.name]} />
            <Input
              name={formSchema.projectCode.name}
              defaultValue={formSchema.projectCode.value}
              inputRef={register(isValidators(formSchema.projectCode.validators))}
              placeholder={'กรุณากรอก' + formSchema.projectCode.label}
              disabled={formSchema.projectCode.disabled}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>Mode :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.modeGrantPay.name]} />
            <Controller
              name={formSchema.modeGrantPay.name}
              control={control}
              defaultValue={formSchema.modeGrantPay.value}
              rules={isValidators(formSchema.modeGrantPay.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.modeGrantPay.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'กรุณาเลือก'}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>
            <CancelButton>{'ยกเลิก'}</CancelButton>
          </Col>
        </Row>
      </Panel>
      <hr />
      <Panel collapsible defaultExpanded header={'Commit งบ'}>
        <Row>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>รหัสโครงการ :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.projectCode.name]} />
            <Input
              name={formSchema.projectCode.name}
              defaultValue={formSchema.projectCode.value}
              inputRef={register(isValidators(formSchema.projectCode.validators))}
              placeholder={'กรุณากรอก' + formSchema.projectCode.label}
              disabled={formSchema.projectCode.disabled}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>Mode :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.modeCommit.name]} />
            <Controller
              name={formSchema.modeCommit.name}
              control={control}
              defaultValue={formSchema.modeCommit.value}
              rules={isValidators(formSchema.modeCommit.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.modeCommit.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'กรุณาเลือก'}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>
            <CancelButton>{'ยกเลิก'}</CancelButton>
          </Col>
        </Row>
      </Panel>
      <hr />
      <Panel collapsible defaultExpanded header={'ยกเลิกการจองงบ'}>
        <Row>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>รหัสโครงการ :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.projectCode.name]} />
            <Input
              name={formSchema.projectCode.name}
              defaultValue={formSchema.projectCode.value}
              inputRef={register(isValidators(formSchema.projectCode.validators))}
              placeholder={'กรุณากรอก' + formSchema.projectCode.label}
              disabled={formSchema.projectCode.disabled}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <b>Mode :</b>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.modeReject.name]} />
            <Controller
              name={formSchema.modeReject.name}
              control={control}
              defaultValue={formSchema.modeReject.value}
              rules={isValidators(formSchema.modeReject.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={formSchema.modeReject.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    searchable={false}
                    placeholder={'กรุณาเลือก'}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 30 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>
            <CancelButton>{'ยกเลิก'}</CancelButton>
          </Col>
        </Row>

        <ConfirmWidget
          title={'ยืนยันการจองงบโครงการ'}
          show={isShowConfirm}
          onCancle={() => setIsShowConfirm(false)}
          onConfirm={handleCallService}
        />
      </Panel>
      <hr />
    </>
  )
}
